import { render, staticRenderFns } from "./DashboardRider.vue?vue&type=template&id=4311c644"
import script from "./DashboardRider.vue?vue&type=script&lang=js"
export * from "./DashboardRider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports